module.exports = __webpack_public_path__ + "static/img/square-background.871c64c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/square-background.jpg
// module id = vc9v
// module chunks = 1